import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchPublicTestStepResult = async ({ tcrid, companyId, token }) => {
  if (!tcrid || !companyId || !token) throw new Error("Missing required parameters");

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getTestCaseDataReport&companyid=${companyId}&token=${token}&tcrid=${tcrid}`,
  );

  return response.data;
};

const usePublicTestStepResultQuery = (params) => {
  return useQuery({
    queryKey: ["PublicTestStepResult", params],
    queryFn: () => fetchPublicTestStepResult(params),
    retry: true,
    enabled: Boolean(params.tcrid && params.companyId && params.token),
    cacheTime: 0,
    refetchIntervalInBackground: false,
    staleTime: 0,
  });
};

export default usePublicTestStepResultQuery;
